export const actionTypes = {
    AddFrontendAnalytics: "[AddFrontendAnalytics] Action",
    UpdateFrontendAnalytics: "[UpdateFrontendAnalytics] Action",
  };